import React from 'react';
import LinkCard from '../Assets/linksCard'
import InputLinks from '../Assets/linksData'
import BackCard from '../Assets/backCard'
import { NavLink } from 'react-router-dom';

function Recette() {
    return ( <>
        <div className={`${InputLinks.themeMode == 'dark' ? 'bg-dark-theme-2' : '' }`} style={{height: '100vh', overflow: 'scroll'}}>
            <BackCard data={InputLinks.backCard.rt}/>
            <br />
            <br />
            <br />
            <br />
            <div className='container'>
                <div className='row'>
                    {InputLinks.recette.map( (links) => <div  key={links.id}  className='col-12 col-md-6 mb-3'><LinkCard data={links} /></div>)}
                </div>
                {/* <hr /> */}
                <div className={`card card-body shadow-sm border-div mb-2 text-center   ${InputLinks.themeMode == 'dark' ? 'bg-dark-theme-1 text-light' : 'bg-hover-card' }`}  >
                    <NavLink exact='true' to={'enAttent'} className="stretched-link m-0 p-0"></NavLink>
                    <h3> <span className='bi bi-hourglass-bottom me-3'></span> Ticket En Attent  <span className='bi bi-chevron-double-right'></span> </h3>
                </div> 
                {/* <div className='row'>
                    {InputLinks.recette2.map( (links) => <div  key={links.id}  className='col-12 col-md-6 mb-3'><LinkCard data={links} /></div>)}
                </div>   */}
            </div>
        </div>    
        </> );
}

export default Recette;